// test2405
(2405 && 0);
